module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "comp-ctn-docs"
  }, [_c('custom-select-user', {
    attrs: {
      "items": _vm.clients
    },
    model: {
      value: (_vm.currentClient),
      callback: function($$v) {
        _vm.currentClient = $$v
      },
      expression: "currentClient"
    }
  }), _vm._v(" "), (_vm.currentClient) ? _c('div', {
    staticClass: "ctn-missions"
  }, [_vm._l((_vm.missionsWithDocuments), function(mission, key) {
    return _c('div', {
      key: key,
      staticClass: "mission"
    }, [_c('div', {
      staticClass: "mission-name"
    }, [_vm._v("\n\t\t\t\t" + _vm._s(mission.title) + "\n\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "ctn-docs row"
    }, _vm._l((mission.documents), function(doc, keyt) {
      return _c('tile-doc', {
        key: keyt,
        attrs: {
          "doc": doc
        }
      })
    }), 1), _vm._v(" "), (mission.documents.length === 0) ? _c('div', {
      staticClass: "no-docs"
    }, [_vm._v("\n\t\t\t\tPas de documents pour le moment\n\t\t\t")]) : _vm._e()])
  }), _vm._v(" "), (_vm.othersDocs && _vm.othersDocs.length > 0) ? _c('div', {
    staticClass: "mission"
  }, [_c('div', {
    staticClass: "mission-name"
  }, [_vm._v("\n\t\t\t\tAutres\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "ctn-docs row"
  }, _vm._l((_vm.othersDocs), function(doc, keyt) {
    return _c('tile-doc', {
      key: keyt,
      attrs: {
        "doc": doc
      }
    })
  }), 1)]) : _vm._e(), _vm._v(" "), (_vm.missions.length === 0) ? _c('div', {
    staticClass: "no-missions"
  }, [_vm._v("\n\t\t\tPas de missions pour le moment\n\t\t")]) : _vm._e()], 2) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a14f40f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Documents/Operations.vue
// module id = 1123
// module chunks = 0